<tw-modal class="root stake">
  <wrong-network v-if="isWrongSelectedNetwork" :required-blockchain="pool.blockchain" />
  <template v-else>
    <template v-if="step === STEP_HARVEST">
      <h3 class="modal-title">Harvest</h3>
      <form @submit.prevent="()=>{}">
        <div class="info">
          <span class="label">Available Reward:</span> <span class="value">{{ rewardBalanceFormatted }} {{ currency.name }}</span>
        </div>
        <tw-button class="stake-btn" @click="harvest" :loading="harvesting">HARVEST</tw-button>
      </form>
    </template>
    <div
      v-if="[
      STEP_HARVEST_PENDING,
      STEP_HARVEST_FAIL,
      STEP_HARVEST_SUCCESS,
      ].includes(step)"
      class="tx-status"
    >
      <tw-process-state v-if="STEP_HARVEST_PENDING === step" />
      <tw-process-state v-if="STEP_HARVEST_SUCCESS === step" success />
      <tw-process-state v-if="STEP_HARVEST_FAIL === step" error />

      <div class="process-header">
        <template v-if="STEP_HARVEST_PENDING === step">
          Harvesting...
        </template>
        <template v-if="STEP_HARVEST_SUCCESS === step">
          Success
        </template>
        <template v-if="STEP_HARVEST_FAIL === step">
          Error
        </template>
      </div>

      <div class="process-text">
        <template v-if="step === STEP_HARVEST_PENDING">
          <a v-if="explorerLink" class="tx-link" :href="explorerLink" target="_blank">Transaction</a>
          <template v-else>Transaction</template>
          successfully submitted to the blockchain, waiting to be confirmed
        </template>
        <template v-if="STEP_HARVEST_SUCCESS === step">
          <a v-if="explorerLink" class="tx-link" :href="explorerLink" target="_blank">Transaction</a> confirmed successfully
        </template>
        <template v-if="STEP_HARVEST_FAIL === step">
          <div v-if="errorMsg" class="error-msg">
            {{ errorMsg }}
          </div>
          <template v-else>
            Something went wrong. Please try again
          </template>
        </template>
      </div>
    </div>
  </template>
</tw-modal>
